import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import BrandButton from "@/components/ui/BrandButton";
import PasswordInput from "@/components/ui/PasswordInput";
import LanguageSelector from "@/layout/LanguageSelector";
import { COMMIT_SHA } from "@/config";
import "@/pages/page.css";

console.log("GitHub SHA:", COMMIT_SHA);

function LoginPage() {
  const { t } = useTranslation();
  const { login } = useAuth();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    const email = e.target.email.value;
    const password = e.target.password.value;

    try {
      await login(email, password);
      const redirectPath = localStorage.getItem("redirectAfterLogin") || "/";
      localStorage.removeItem("redirectAfterLogin");
      navigate(redirectPath, { replace: true });
    } catch (err) {
      setError(
        err.message ||
          t("auth.authFailed", "Authentication failed. Please try again."),
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-container">
      <main className="content" style={{ marginLeft: 0 }}>
        <div className="d-flex justify-content-end p-3">
          <LanguageSelector />
        </div>
        <div className="row justify-content-center mt-3">
          <div className="col-md-5 col-lg-4">
            <div className="card card-radius">
              <div className="card-body">
                <h3 className="text-center mb-4">{t("auth.login", "Login")}</h3>
                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      {t("auth.email", "Email")}
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="email"
                      name="email"
                      required
                      data-testid="login-email-input"
                    />
                  </div>
                  <div className="mb-3">
                    <label htmlFor="password" className="form-label">
                      {t("auth.password", "Password")}
                    </label>
                    <PasswordInput
                      id="password"
                      name="password"
                      required
                      data-testid="login-password-input"
                    />
                  </div>
                  <BrandButton
                    type="submit"
                    className="w-100"
                    disabled={loading}
                    dataTestId="login-submit-button"
                  >
                    {loading
                      ? t("auth.loggingIn", "Logging in...")
                      : t("auth.login", "Login")}
                  </BrandButton>
                </form>
                <div className="mt-2 text-end">
                  <Link to="/forgot-password">
                    {t("auth.forgotPassword", "Forgot password?")}
                  </Link>
                </div>
                <div className="mt-3 text-center">
                  <span>
                    {t("auth.noAccount", "Don't have an account?")}{" "}
                    <a
                      href="https://setup.elelem.ai"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {t("auth.startToday", "Start today!")}
                    </a>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default LoginPage;
